import { buildApiTypes } from '@/modules/Vuex';

export const { actionTypes: API_GET_PREFERENCES } = buildApiTypes('preferences/API_GET_PREFERENCES');
export const { actionTypes: API_PUT_PREFERENCES_UPDATE } = buildApiTypes('preferences/API_PUT_PREFERENCES_UPDATE');

export const UPDATE_STATE_USER_PREFERENCES = 'preferences/UPDATE_STATE_USER_PREFERENCES';
